export default {
  componentsLoading: true,
  components: null,
};
